import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { SoloModeProvider } from './providers/solo-mode.provider';
import { DomUtils } from './shared/dom-utils';
import Utils, { MessageType } from './shared/utils';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  private previousContentHeight: number;
  public canUseLocalStorage: boolean = false;

  constructor(private elementRef: ElementRef, private soloModeProvider: SoloModeProvider) {}

  ngOnInit(): void {
    this.checkIfCanAccessLocalStorage();
    this.soloModeProvider.storeState();
  }

  ngAfterViewInit() {
    DomUtils.onResize(this.elementRef.nativeElement, () => {
      this.sendContentHeightToHostPage();
    });
  }

  private sendContentHeightToHostPage(): void {
    // It seems like on Windows only, element’s scrollHeight is rounded
    // down to the nearest integer. Because of this when the widget
    // content height is a fractional numbed — say 515.5 pixels — the
    // iframe gets only 515 pixels, which leads to the vertical
    // scroll-bar coming up.
    const contentHeight = this.elementRef.nativeElement.getBoundingClientRect().height;

    if (contentHeight === this.previousContentHeight) {
      return;
    }

    Utils.postMessageToParentWindow(MessageType.height, contentHeight);
    this.previousContentHeight = contentHeight;
  }

  private checkIfCanAccessLocalStorage() {
    try {
      const key = 'testing';
      const storedValue = 'test string';

      localStorage.setItem(key, storedValue);

      const retrievedValue = localStorage.getItem('testing');

      if (retrievedValue === storedValue) {
        this.canUseLocalStorage = true;
      } else {
        this.canUseLocalStorage = false;
        console.error('canUseLocalStorage? Can’t retrieve the stored value?!', { key, storedValue, retrievedValue });
      }

      localStorage.removeItem(key);
    } catch (error) {
      this.canUseLocalStorage = false;
      console.error('canUseLocalStorage? Error:', error);
    }
  }
}
